// Edit plan form
import React, { useEffect, useState } from 'react'
import { MdArrowDropDown } from "react-icons/md";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import Sidebar from '../Components/Sidebar';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export default function EditPlan() {
    const navigate = useNavigate();
    const { plan_id } = useParams();
    const planId = plan_id;
    const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
    const [planname, setPlanname] = useState('');
    const [price, setPrice] = useState('');
    const [planevalidity, setPlanevalidity] = useState('');
    const [validityUnit, setValidityUnit] = useState('days');
    const [planevisibility, setPlanevisibility] = useState([]);
    const [subscription, setSubscription] = useState([]);
    const [totalCount1, setTotalCount1] = useState(null);
    const [SelectedSubscription, setSelectedSubscription] = useState({})
    const [yourDataArray, setYourDataArray] = useState([
        { id: 1, planname: 'Super Admin' },
        { id: 2, planname: 'Admin' },
        { id: 3, planname: 'Affiliate' },
        { id: 4, planname: 'User' },
    ]);

    // toggle dropdown
    const toggleDropdownfilter = () => {
        setIsDropdownOpenfilter(!isDropdownOpenfilter);
    };

    // Checkbox state 
    const [checkboxStates, setCheckboxStates] = useState(subscription.map(() => false));
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    // Function to handle checkbox change for a specific item
    const handleCheckboxChanged = (index) => {
        const newCheckboxStates = [...checkboxStates];
        newCheckboxStates[index] = !newCheckboxStates[index];
        setCheckboxStates(newCheckboxStates);

        const selectedAccess = subscription
            .filter((_, i) => newCheckboxStates[i])
            .map(item => item.planname);
        setPlanevisibility(selectedAccess);
    };

    // Function to handle "Select All" checkbox change
    const handleSelectAllChanged = () => {
        setSelectAllChecked(!selectAllChecked);
        setCheckboxStates(Array(subscription.length).fill(!selectAllChecked));

        // Update the access state based on selected checkboxes
        const selectedAccess = subscription
            .map((item, i) => (!selectAllChecked || checkboxStates[i]) ? item.planname : null)
            .filter(Boolean);
        setPlanevisibility(selectedAccess);
    };

    const countCheckedUsers = () => {
        const checkedCount = checkboxStates.filter((isChecked) => isChecked).length;
        return checkedCount;
    };
    // get api 
    useEffect(() => {
        const fetchSubscription = async () => {
            try {
                const response = await fetch(`${Constant.BASE_URL}/subscription/get`);
                const data = await response.json();

                if (data && data.subscription) {
                    setSubscription(data.subscription);
                    setCheckboxStates(data.subscription.map(() => false)); // Set checkbox states here
                    if (data.success) {
                        setTotalCount1(data.totalCount);
                    }
                }
            } catch (error) {
                console.error("Error fetching subscription:", error);
            }
        };

        fetchSubscription();
    }, []);


    useEffect(() => {
        if (subscription.length > 0) {
            getSubscriptionById(plan_id)
        }
    }, [subscription])

    useEffect(() => {
        setValue()
    }, [SelectedSubscription])

    const setValue = () => {
        setPlanname(SelectedSubscription.planname)
        setPrice(SelectedSubscription.price)
        setPlanevalidity(SelectedSubscription.planevalidity || '')
        setValidityUnit(SelectedSubscription.validityUnit || 'days')
        setPlanevisibility(SelectedSubscription.planevisibility)
    }

    const getSubscriptionById = (id) => {
        setSelectedSubscription(
            subscription.find((item) => {
                return item._id == id
            })
        )
        // setSelectedAffiliate
    }
    // update api 
    const handleUpdate = async (e) => {
        e.preventDefault();

        try {
            const subscriptionData = {
                planname,
                price,
                planevalidity: Number(planevalidity),
                validityUnit,
                planevisibility
            };
            const response = await axios.put(`${Constant.BASE_URL}/subscription/update/${planId}`, subscriptionData);
            if (response.status === 200) {
                setPrice('');
                setPlanname('');
                setPlanevisibility([]);


                toast.success("Plan created successfully");

                setTimeout(() => {
                    navigate("/subscription");

                }, 3000);
            } else {
                console.log("Update failed:", response.status);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Sidebar>
            <>
                <ToastContainer position="top-right" autoClose={3000} />

                <div className=''>
                    {SelectedSubscription ? (
                        <div>
                            <div className="flex justify-center ">
                                <div className="absolute lg:top-[170px] xl:top-[250px] 2xl:top-[590px]  flex items-center justify-center z-10">
                                    <div className="p-4 px-1 py-3 bg-white rounded-md lg:py-3 xl:py-3 2xl:p-4 ">
                                        <div className="lg:w-[250px] xl:w-[270px] 2xl:w-[380px] items-center justify-center">
                                            <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl ">
                                                Edit Plan
                                            </div>
                                            <hr className="mt-1 " />

                                            <form onSubmit={handleUpdate}>
                                                <div className="flex flex-col items-center justify-center ">
                                                    <div className='lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]'>
                                                        <div className="flex items-center justify-end py-3">
                                                            <label htmlFor="yourInput" className="flex items-end px-3">
                                                                Plan Name :<span className="ml-1 text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="yourInput"
                                                                className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                                style={{ width: '163px', textAlign: 'center' }}
                                                                placeholder="Text"
                                                                value={planname || ''}
                                                                onChange={(e) => setPlanname(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="flex items-center justify-end py-3">
                                                            <label htmlFor="yourInput" className="flex items-end px-3">
                                                                Price (rs.) :<span className="ml-1 text-red-500">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="price"
                                                                name="price"
                                                                className="flex items-start mb-2 border-b border-gray-500 outline-none "
                                                                style={{ width: '163px', textAlign: 'center' }}
                                                                placeholder="Amount"
                                                                value={price || ''}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="flex items-center justify-end py-3">
                                                            <label htmlFor="validityInput" className="flex items-end px-3">
                                                                Validity :<span className="ml-1 text-red-500">*</span>
                                                            </label>
                                                            <div className="flex items-center gap-2" style={{ width: '163px' }}>
                                                                <input
                                                                    type="number"
                                                                    id="validityInput"
                                                                    className="flex items-start mb-2 border-b border-gray-500 outline-none"
                                                                    style={{ width: '80px', textAlign: 'center' }}
                                                                    placeholder="e.g. 30"
                                                                    value={planevalidity || ''}
                                                                    onChange={(e) => setPlanevalidity(e.target.value)}
                                                                    min="1"
                                                                    required
                                                                />
                                                                <select
                                                                    value={validityUnit}
                                                                    onChange={(e) => setValidityUnit(e.target.value)}
                                                                    className="mb-2 border-b border-gray-500 outline-none bg-white"
                                                                    style={{ width: '75px', textAlign: 'center' }}
                                                                >
                                                                    <option value="days">Days</option>
                                                                    <option value="hours">Hours</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-end">
                                                            <div className="flex items-center justify-end py-1 mb-16">
                                                                <label htmlFor="yourInput" className="flex items-end px-3">
                                                                    <p className="text-black">Plan Visibility :{countCheckedUsers()} selected/{totalCount1}</p>
                                                                </label>
                                                                <div className="relative" >
                                                                    <div >
                                                                        <div onClick={toggleDropdownfilter} className="border-b border-black cursor-pointer focus:outline-none ">
                                                                            <div className="w-[140px] flex  items-center justify-end relative px-5 lg:px-2">
                                                                                <p className='text-4lg 2xl:text-4xl lg:text-[10px] xl:text-[15px]  bg-white shadow-md border border-white '> </p> <MdArrowDropDown className="pt-1 text-2xl shadow-md " />
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    {/* Dropdown Content */}
                                                                    {isDropdownOpenfilter && (
                                                                        <div
                                                                            style={{
                                                                                boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
                                                                                borderRadius: '0 0 5px 5px',
                                                                                zIndex: '100',
                                                                                background: 'rgba(0, 0, 0, 0.25)',
                                                                            }}
                                                                            className="lg:text-[10px]  lg:w-fit xl:text-[15px] absolute top-9 left-25 bg-white border border-white border-opacity-60 bg-white"
                                                                        >
                                                                            {/* Dropdown Options */}
                                                                            <ul className='overflow-y-auto h-[130px] createmodal'>

                                                                                {/* "Select All" checkbox */}
                                                                                <li className="flex items-center justify-between px-2 py-1 text-black border-t cursor-pointer">
                                                                                    <span className='text-[12px]'>All</span>
                                                                                    <div className='flex items-center justify-end'>
                                                                                        <label className="inline-flex items-center">
                                                                                            <div className={`w-4 h-4 bg-white  border-red-500 rounded-sm flex items-center justify-center ml-2 ${selectAllChecked ? 'bg-red-500' : ''}`}>
                                                                                                {selectAllChecked && (
                                                                                                    <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                                )}
                                                                                            </div>
                                                                                            <input
                                                                                                className="hidden"
                                                                                                type="checkbox"
                                                                                                checked={selectAllChecked}
                                                                                                onChange={handleSelectAllChanged}
                                                                                            />
                                                                                        </label>
                                                                                    </div>
                                                                                </li>

                                                                                {yourDataArray.map((item, index) => (
                                                                                    <div key={item.id} className="flex items-center justify-between px-2 py-1 text-black border-t cursor-pointer">
                                                                                        <span className='text-[12px]'>{item.planname}</span>
                                                                                        <div className='flex items-center'>
                                                                                            <label className="inline-flex items-center">
                                                                                                <div
                                                                                                    className={`w-4 h-4 bg-white border-red-500 rounded-sm flex items-center justify-center ml-2 ${checkboxStates[index] ? '' : ''
                                                                                                        }`}
                                                                                                >
                                                                                                    {checkboxStates[index] && (
                                                                                                        <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                                                                                    )}
                                                                                                </div>

                                                                                                <input
                                                                                                    className="hidden"
                                                                                                    type="checkbox"
                                                                                                    checked={checkboxStates[index]}
                                                                                                    onChange={() => handleCheckboxChanged(index)}
                                                                                                />

                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="button-container flex justify-center p-1 space-x-12 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                                            <Link to="/subscription">
                                                                <button
                                                                    type="button"

                                                                    className="flex-shrink-0 px-3 py-1 bg-white shadow-md "
                                                                    style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </Link>
                                                            <button
                                                                type="submit"
                                                                className="flex-shrink-0 px-3 py-1 "
                                                                style={{
                                                                    background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                                                }}
                                                            >
                                                                Save
                                                            </button>

                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </>
        </Sidebar>
    )
}
